import { Dashboard } from '@aidkitorg/aidkit/lib/admin_panel/dashboards';
import { Button, Card, CardBody, DataTable } from '@aidkitorg/component-library';
import { ColumnDef } from '@tanstack/react-table';
import React from 'react';
import { useDashboards } from '../../../Contexts/DashboardsContext';
import { useLocalizedStrings } from '../../../Localization';
import { useHistory } from 'react-router-dom';
import { useAsyncEffect } from '../../../Hooks/AsyncEffect';

export const DashboardsDataTable = () => {
  const L = useLocalizedStrings()
  const history = useHistory()
    
  const { dashboards, isDashboardsLoading, getDashboards } = useDashboards()
  
  useAsyncEffect(async () => {
    getDashboards()
  }, []);

  const DASHBOARD_COLUMNS: ColumnDef<Dashboard>[] = [
    {
      accessorKey: 'title',
      header: 'Dashboard Name',
      cell: ({ row }) => {
        const dashboardId = row.original.id
        return (
          <Button 
            className="font-medium"
            variant="link"
            onClick={(e) => {
              history.push("/admin-panel/my-dashboards/"+dashboardId)
            }}
          >
            {row.original.title}
          </Button>
        )
      }
    },
    {
      accessorKey: 'description',
      header: 'Description',
      cell: ({ row }) => (
        <span className="text-gray-700">{row.original.description}</span>
      )
    }, 
    {
      accessorKey: 'updated_at',
      header: 'Updated On',
      cell: ({ row }) => {
        if (!row.original.updated_at) return "--"
        const date = new Date(row.original.updated_at)
        const formatted = new Intl.DateTimeFormat("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        }).format(date)
  
        return <span>{formatted}</span>
      },
    },
    {
      accessorKey: 'created_by',
      header: 'Created By',
    }
  ]


  const dashboardsEmptyState = (
    <div className="py-2 text-center text-gray-600 flex flex-col gap-y-4">
      <div>
        {L.admin_panel.dashboards.dashboards_empty_msg}
      </div>
      <div>
        <Button 
          onClick={(e) => {
            history.push('/admin-panel/my-dashboards/dashboard-builder')
          }}
        >
          {L.admin_panel.dashboards.create_new_dashboard}
        </Button>
      </div>
    </div>
  )

  const dashboardsEmpty = !isDashboardsLoading && dashboards.length === 0

  return (
    <Card className="rounded-md">
      <CardBody>
        {dashboardsEmpty ? dashboardsEmptyState : 
          <DataTable
            columns={DASHBOARD_COLUMNS}
            data={dashboards}
            enableSearch
            searchLabel="Search dashboards..."
            loading={isDashboardsLoading}
            showPagination
          />
        }
      </CardBody>
    </Card>
  )
}